import React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import buildUrl from 'modules/core/lib/buildUrl'
import helpCenterUrl from 'modules/core/lib/helpCenterUrl'
import i18n from 'modules/core/lib/i18n'

function HelpFooter() {
  return (
    <Box
      width="full"
      height="s80"
      justifyContent="spaceBetween"
      flexDirection="row"
      border={{
        all: {
          color: 'grey400',
          width: 's1',
          style: 'solid',
        },
      }}
      borderRadius={{ all: 'abs008' }}
      paddingX="s32"
      gap="s24"
    >
      <Box width="fit-content" flexDirection="row" alignItems="center" overflowX="hidden">
        <Text size="300" weight="medium" ellipsis>
          {i18n.t('security_settings.help_footer.title')}
        </Text>
      </Box>
      <Box flexDirection="row" alignItems="center" gap="s24">
        <Button.Router to={helpCenterUrl('about-security-settings')} blankTarget>
          {i18n.t('security_settings.help_footer.help_center_button')}
        </Button.Router>
        <Button.Router to={buildUrl('/canny/sso')} blankTarget>
          {i18n.t('security_settings.help_footer.feedback_button')}
        </Button.Router>
      </Box>
    </Box>
  )
}

export default React.memo(HelpFooter)
